import React from "react";
import PropTypes from "prop-types";
import { LoadableLinkButton } from "venuescanner-js/react/components/Buttons/LinkButton";

const ForgotPassword = ({ children }) => {
  return (
    <>
      <LoadableLinkButton
        onClick={() => (window.location = "/reset-your-password")}
      >
        {children || "Forgot password"}
      </LoadableLinkButton>
    </>
  );
};

ForgotPassword.propTypes = {
  children: PropTypes.node,
};

export default ForgotPassword;
